var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag",class:_vm.classes,attrs:{"title":_vm.title,"data-testid":"tag"},on:{"click":_vm.onClick}},[_vm._t("left-icon"),_c('span',{staticClass:"tag-text",class:{
            'with-left-icon': _vm.$slots['left-icon'],
            'with-right-icon': _vm.$slots['right-icon'],
        }},[_vm._t("content",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),_vm._t("right-icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }